// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZaiPrePromptLink .ZaiTagButton {
  width: auto;
}
.ZaiPrePromptLink .ZaiTagButton:hover {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-pre-prompt-link/zai-pre-prompt-link.styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAEI;EACE,gBAAA;AAAN","sourcesContent":[".ZaiPrePromptLink {\n  .ZaiTagButton {\n    width: auto;\n\n    &:hover {\n      box-shadow: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
